<template>
  <a-card>
    <div slot="title" class="title">
      <div class="vertical"></div>
      年度公司投资总额
    </div>
    <div slot="extra" class="extra">
      <a-date-picker
        mode="year"
        placeholder="请选择年份"
        format="YYYY"
        valueFormat="YYYY"
        v-model="year"
        style="100%"
        :open="yearShowOne"
        @openChange="openChangeOne"
        @panelChange="panelChangeOne"
      />
    </div>
    <div class="main">
      <gross-assets-bar :data="userwaterList"></gross-assets-bar>
    </div>
  </a-card>
</template>

<script>
import GrossAssetsBar from '../module/gross-assets-bar.vue'
export default {
  components: {
    GrossAssetsBar,
  },
  data() {
    return {
      userwaterList: {},
      year: '',
      yearShowOne: false,
      yeare: '',
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 弹出日历和关闭日历的回调
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true
      }
    },
    // 得到年份选择器的值
    panelChangeOne(value, dateString) {
      this.year = value
      this.yearShowOne = false
      this.yeare = value.format('yyy')
      this.getList()
    },
    //年度公司投资总额
    getList() {
      this.$http
        .get('/pipe-network//engineering_project_checks/left-lower', {
          params: {
            year: this.yeare,
          },
        })
        .then((res) => {
          let list = res.data
          var xdata = []
          var sdata = []
          list.map((item) => {
            xdata.push(item.executeUserName.substring(5)+'月')
            sdata.push(item.money)
          })
          this.userwaterList = {
            xdata: xdata,
            sdata: sdata,
            grid: {
              x: '18%', //左侧与y轴的距离
              y: '12%', //top部与x轴的距离
              x2: '2%', //右侧与y轴的距离
              y2: '12%', //bottom部与x轴的距离
            },
          }
        })
    },
  },
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}
.a-card {
  width: 100%;
  height: 100%;
}
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.title {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.main {
  width: 100%;
  height: 269px;
}
</style>